var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useContext } from "react";
import { ThemeContext, css } from "styled-components";
import { media } from "./mixins";

// Blacklists props that shouldn't end up on the DOM node
// If error, check if comp needs React.forwardRef()
// Usage: const Component = styled(safeElement())` ... `;
var safeElement = function safeElement() {
  return function (props) {
    var color = props.color,
        size = props.size,
        display = props.display,
        bold = props.bold,
        gutterBottom = props.gutterBottom,
        uppercase = props.uppercase,
        height = props.height,
        bgColor = props.bgColor,
        borderColor = props.borderColor,
        borderRadius = props.borderRadius,
        fluid = props.fluid,
        hoverColor = props.hoverColor,
        clickColor = props.clickColor,
        variant = props.variant,
        m = props.m,
        noHoverAnimation = props.noHoverAnimation,
        paddingRight = props.paddingRight,
        paddingLeft = props.paddingLeft,
        loading = props.loading,
        textColor = props.textColor,
        width = props.width,
        order = props.order,
        hide = props.hide,
        forwardedRefSafe = props.forwardedRefSafe,
        gap = props.gap,
        flexDirection = props.flexDirection,
        justifyContent = props.justifyContent,
        thin = props.thin,
        wide = props.wide,
        primary = props.primary,
        pill = props.pill,
        ultrathin = props.ultrathin,
        basic = props.basic,
        compact = props.compact,
        iconLeft = props.iconLeft,
        iconRight = props.iconRight,
        $as = props.$as,
        softUpperLeftCorner = props.softUpperLeftCorner,
        skipLeftMargin = props.skipLeftMargin,
        spanGapRight = props.spanGapRight,
        background = props.background,
        span = props.span,
        spanMarginLeftArray = props.spanMarginLeftArray,
        spanArray = props.spanArray,
        wrapped = props.wrapped,
        gapArray = props.gapArray,
        addPaddingLeftArray = props.addPaddingLeftArray,
        addPaddingRightArray = props.addPaddingRightArray,
        spanMarginRightArray = props.spanMarginRightArray,
        base = props.base,
        orderArray = props.orderArray,
        hideArray = props.hideArray,
        align = props.align,
        softRightCorner = props.softRightCorner,
        pt = props.pt,
        pb = props.pb,
        pv = props.pv,
        mv = props.mv,
        justifyItems = props.justifyItems,
        alignItems = props.alignItems,
        justifySelf = props.justifySelf,
        alignSelf = props.alignSelf,
        tone = props.tone,
        labelSizeArray = props.labelSizeArray,
        reserveMessageSpace = props.reserveMessageSpace,
        largeMarginBottom = props.largeMarginBottom,
        extraBold = props.extraBold,
        restProps = _objectWithoutProperties(props, ["color", "size", "display", "bold", "gutterBottom", "uppercase", "height", "bgColor", "borderColor", "borderRadius", "fluid", "hoverColor", "clickColor", "variant", "m", "noHoverAnimation", "paddingRight", "paddingLeft", "loading", "textColor", "width", "order", "hide", "forwardedRefSafe", "gap", "flexDirection", "justifyContent", "thin", "wide", "primary", "pill", "ultrathin", "basic", "compact", "iconLeft", "iconRight", "$as", "softUpperLeftCorner", "skipLeftMargin", "spanGapRight", "background", "span", "spanMarginLeftArray", "spanArray", "wrapped", "gapArray", "addPaddingLeftArray", "addPaddingRightArray", "spanMarginRightArray", "base", "orderArray", "hideArray", "align", "softRightCorner", "pt", "pb", "pv", "mv", "justifyItems", "alignItems", "justifySelf", "alignSelf", "tone", "labelSizeArray", "reserveMessageSpace", "largeMarginBottom", "extraBold"]);

    var Element = $as || "div";
    return React.createElement(Element, _extends({ ref: forwardedRefSafe }, restProps));
  };
};

/*
 * Takes a string,
 * tries to match it with a key in theme.colors,
 * then tries to match with a key in theme,
 * then outputs the original string
 */
export { safeElement };
export var colorFromTheme = function colorFromTheme(color) {
  var theme = useContext(ThemeContext);
  var $$ = void 0;
  if (theme.colors[color]) {
    $$ = theme.colors[color];
  } else if (theme[color]) {
    $$ = theme[color];
  } else {
    $$ = color;
  }
  return $$;
};

/*
 * Checks if is array, creates array and warns if array is constructed wrong
 */

export function breakPointArrayCleaner(arr) {
  if (typeof arr === "string" || typeof arr === "number" || typeof arr === "boolean") {
    arr = [arr, arr, arr, arr];
  } else if (arr.length) {
    if (arr.length === 1) arr = [arr[0], arr[0], arr[0], arr[0]];
    if (arr.length === 2) arr = [arr[0], arr[1], arr[1], arr[1]];
    if (arr.length === 3) arr = [arr[0], arr[1], arr[2], arr[2]];
    if (arr.length > 4) console.error("The helper-function \"breakPointArrayCleaner\" was passed an array (" + JSON.stringify(arr) + ") that is too long (max length 4)");
  } else {
    console.warn("The helper-function \"breakPointArrayCleaner\" was passed a type it doesn't recognize (must be a string/number value or an array of strings/values).");
  }
  return arr;
}

function rem(value) {
  if (typeof value === "string" || typeof value === "boolean") {
    return value;
  } else if (typeof value === "number") {
    return value + "rem";
  }
}

export function breakPointArrayCleanerRem(arr) {
  if (typeof arr === "string" || typeof arr === "number" || typeof arr === "boolean") {
    var x = rem(arr);
    arr = [x, x, x, x];
  } else if (arr.length) {
    if (arr.length === 1) arr = [rem(arr[0]), rem(arr[0]), rem(arr[0]), rem(arr[0])];
    if (arr.length === 2) arr = [rem(arr[0]), rem(arr[1]), rem(arr[1]), rem(arr[1])];
    if (arr.length === 3) arr = [rem(arr[0]), rem(arr[1]), rem(arr[2]), rem(arr[2])];
    if (arr.length === 4) arr = [rem(arr[0]), rem(arr[1]), rem(arr[2]), rem(arr[3])];
    if (arr.length > 4) console.warn("The helper-function \"breakPointArrayCleanerRem\" was passed an array (" + JSON.stringify(arr) + ") that is too long (max length 4)");
  } else {
    console.warn("The helper-function \"breakPointArrayCleanerRem\" somewhere was passed a type it doesn't recognize (must be a string/number value or an array of strings/values).");
  }

  return arr;
}

export var responsiveArraySpreader = function responsiveArraySpreader(ruleFunc) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  return css(["", " ", " ", " ", "  "], media.only.phone(css(["", ""], ruleFunc.apply(undefined, values.map(function (val) {
    return val[0];
  })))), media.only.tablet(css(["", ""], ruleFunc.apply(undefined, values.map(function (val) {
    return val[1];
  })))), media.only.desktop(css(["", ""], ruleFunc.apply(undefined, values.map(function (val) {
    return val[2];
  })))), media.only.wide(css(["", ""], ruleFunc.apply(undefined, values.map(function (val) {
    return val[3];
  })))));
};